import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
//import "./TermsAndConditionsPage.scss";
import { connect } from "react-redux";
import { showMessageBox } from "../../redux/actions/messageBoxActions";
import {
  showLoadingScreen,
  hideLoadingScreen,
} from "../../redux/actions/loadingScreenActions";
import { errorTypesEnum } from "./../../utility/enums";
import PageHeader from "../../components/pageHeader/PageHeader";
import {
  updateResponsive,
  resetResponsive,
} from "../../redux/actions/responsiveActions";
import { responsiveScreenSizesEnum } from "../../utility/enums";
import MessageBox from "../../components/common/messageBox/MessageBox";
import LoadingScreen from "../../components/loadingScreen/LoadingScreen";
import { RichTextRenderer } from "../../components/contentful/RichTextRenderer";
import { get, post } from "../../utility/apiClient";
import { addUserDetail } from "../../redux/actions/userDetailsActions";
import { guestLoginV2 } from "../../utility/v2.0/commonFunctionsV2";

function mapStateToProps(state) {
  return {
    deviceType: state.responsive,
    loadingScreenVisible: state.loadingScreen,
  };
}

// map the redux actions to props
const mapDispatchToProps = {
  updateResponsive,
  resetResponsive,
  showLoadingScreen,
  hideLoadingScreen,
  showMessageBox,
  addUserDetail,
};

class KeellsNexusTermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AuthCode: false,
      activeTab: 1,
      focusQuestion: "",
      locale: "en-US",
      termsJson: null,
    };
    this.responsive = this.responsive.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.fetchPolicy = this.fetchPolicy.bind(this);
    this.guestLogin = this.guestLogin.bind(this);
  }

  componentDidMount() {
    this.responsive();
    window.addEventListener("resize", this.responsive);
    this.setState({
      AuthCode:
        this.props.match.path.split("/")[1] === "termsandconditions" ||
        this.props.match.path.split("/")[1] === "mobtc"
          ? true
          : false,
      focusQuestion: this.props.match ? this.props.match.params.question : "",
    });
    let parameter = window.location.pathname.split("/mobtc");
    if (parameter[1] === "/nexus") {
      document
        .getElementById(`keells_nexus`)
        .scrollIntoView({ behavior: "smooth" });
    }
    if (parameter[1] === "/donation") {
      document
        .getElementById(`keells_donation`)
        .scrollIntoView({ behavior: "smooth" });
    }
    if (parameter[1] === "/mealcard") {
      document
        .getElementById(`keells_mealcard`)
        .scrollIntoView({ behavior: "smooth" });
    }
    if (
      this.props.match.path.split("/")[1] === "mobtc" ||
      this.props.match.path.split("/")[1] === "mobKeellsnexusTermsAndConditions"
    )
      this.guestLogin();
    else this.fetchPolicy();
  }

  guestLogin() {
    guestLoginV2()
      .then(() => this.fetchPolicy())
      .catch(() => {});
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.responsive);
  }

  responsive() {
    if (window.outerWidth <= responsiveScreenSizesEnum.mobileSmallScreen) {
      let screen = {
        isTabScreen: false,
        isMobileLargeScreen: false,
        isMobileSmallScreen: true,
      };
      this.props.updateResponsive(screen);
    } else if (
      window.outerWidth <= responsiveScreenSizesEnum.mobileLargeScreen
    ) {
      let screen = {
        isTabScreen: false,
        isMobileLargeScreen: true,
        isMobileSmallScreen: false,
      };
      this.props.updateResponsive(screen);
    } else if (window.outerWidth <= responsiveScreenSizesEnum.tabScreenSize) {
      let screen = {
        isTabScreen: true,
        isMobileLargeScreen: false,
        isMobileSmallScreen: false,
      };
      this.props.updateResponsive(screen);
    } else {
      this.props.resetResponsive();
    }
  }

  handleLanguageChange = (locale) => {
    this.setState({ locale: locale });
  };

  componentDidUpdate(_, prevState) {
    if (prevState.locale !== this.state.locale) {
      this.fetchPolicy();
    }
  }

  fetchPolicy = () => {
    this.props.showLoadingScreen();
    get(
      "/ContentfulDetail/GetTermsConditionDetail?locale=" + this.state.locale
    ).then((res) => {
      if (res.data.statusCode == 200 && res.data.result) {
        let jsonString = JSON.parse(res.data.result);
        this.setState({
          termsJson: jsonString.fields && jsonString.fields.content,
        });
      } else {
        let errorType = res.data.errorList[0].errorType;
        let messageBox = {
          show: true,
          title:
            errorTypesEnum.error === errorType
              ? "Oops!"
              : errorTypesEnum.warning === errorType
              ? "Warning"
              : "Information",
          className:
            errorTypesEnum.error === errorType
              ? "error"
              : errorTypesEnum.warning === errorType
              ? "warning"
              : "info",
          content: res.data.errorList[0].statusMessage,
          isConfirmation: false,
        };
        this.props.showMessageBox(messageBox);
      }
      this.props.hideLoadingScreen();
    });
  };

  render() {
    const pageHeaderImage =
      this.props.deviceType.isMobileLargeScreen ||
      this.props.deviceType.isMobileSmallScreen
        ? "https://essstr.blob.core.windows.net/uiimg/PageHeader/term&condition-mobile-banner.jpg"
        : "https://essstr.blob.core.windows.net/uiimg/PageHeader/term&condition-web-banner.jpg";
    var breadcrumb = "",
      noCrumb = true;
    if (
      this.props.match.path.split("/")[1] !== "mobKeellsnexusTermsAndConditions"
    ) {
      breadcrumb = "Terms and Conditions";
      noCrumb = false;
    }
    return (
      <React.Fragment>
        <PageHeader
          breadcrumb={breadcrumb}
          noCrumb={noCrumb}
          headerText="Keells nexus Terms & Conditions"
          imageUrl={pageHeaderImage}
        >
          <div>
            <button
              type="button"
              className="btn white-button me-2"
              style={{
                marginRight: "5px",
                borderColor: "white",
                color: "white",
                cursor: "pointer",
                background: this.state.locale == "si" ? "green" : "",
              }}
              onClick={() => this.handleLanguageChange("si")}
            >
              සිංහල
            </button>
            <button
              type="button"
              className="btn white-button me-2"
              style={{
                marginRight: "5px",
                borderColor: "white",
                color: "white",
                cursor: "pointer",
                background: this.state.locale == "ta" ? "green" : "",
              }}
              onClick={() => this.handleLanguageChange("ta")}
            >
              தமிழ்
            </button>
            <button
              type="button"
              className="btn white-button me-2"
              style={{
                marginRight: "5px",
                borderColor: "white",
                color: "white",
                cursor: "pointer",
                background: this.state.locale == "en-US" ? "green" : "",
              }}
              onClick={() => this.handleLanguageChange("en-US")}
            >
              English
            </button>
          </div>
        </PageHeader>
        <Col
          lg={{ span: 10, offset: 1 }}
          md="12"
          className="mt-5 mb-5"
          style={{ maxHeight: "none" }}
        >
          <br></br>
          <Row
            className="col-lg-12 col-md-12 col-sm-12 col-12"
            style={{ align: "left" }}
          >
            <div
              className="container"
              lang={this.state.locale}
              style={{
                maxHeight: "none",
                //wordBreak: this.state.locale == "ta" ? "break-all" : "",
                //overflowWrap: this.state.locale == "ta" ? "break-word" : "",
                hyphens: "auto",
              }}
            >
              {this.state.termsJson && (
                <RichTextRenderer
                  document={this.state.termsJson}
                ></RichTextRenderer>
              )}
            </div>
          </Row>
        </Col>
        <MessageBox />
        <LoadingScreen isVisible={this.props.loadingScreenVisible} />
      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeellsNexusTermsAndConditions);
